import { render, staticRenderFns } from "./FacilityCreatedDialog.vue?vue&type=template&id=454b5ed0&scoped=true&"
import script from "./FacilityCreatedDialog.vue?vue&type=script&lang=js&"
export * from "./FacilityCreatedDialog.vue?vue&type=script&lang=js&"
import style0 from "./FacilityCreatedDialog.vue?vue&type=style&index=0&id=454b5ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b5ed0",
  null
  
)

export default component.exports